// extracted by mini-css-extract-plugin
export var productImage = "_101-0";